import React from "react";
import NewestCollection from "../../../components/_home/NewestCollection/NewestCollection";
import { newest } from "../../../mock/newest";
import styles from "./Favorites.module.scss";

const Favorites = () => {
  return (
    <div className={styles.container}>
      {newest.map((i) => (
        <NewestCollection
          key={i.id}
          name={i.name}
          creator={i.creator}
          media={i.media}
          type={i.type}
          price={i.price}
          likes={i.likes}
        />
      ))}
    </div>
  );
};

export default Favorites;
